import { useEffect, useState } from 'react';
import { resolveImage } from "../../images/ImageResolver";
import WealthPackages from './WealthPackages';
import HighLevel from './HighLevel';
import MidLevel from './MidLevel';
import { FilterInput, RowFiltering, AutoTooltip } from '@refinitiv-ui/efx-grid/extensions';
import { fetchData, textWithIcon, styles } from './Helpers';

function DocumentMapping({ view, setView }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData("Filings_Edgar").then(res => {
      setData(res);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const grid = document.getElementById("grid");
    const filterInputExt = new FilterInput();
    const rowFilteringExt = new RowFiltering();
    const autoToolTipExt = new AutoTooltip();
    const columns = [
      { name: 'Document Type', field: 'documentType', leftPinned: true, scalable: true},
      { name: 'Submission Type Code', field: 'gstCode', scalable: true,styles: styles },
      { name: 'Submission Type', field: 'stdValue', scalable: true},
      { name: 'High Level Category ID', field: 'highLevelId', scalable: true, headerBinding: headerWithLink1,styles: styles },
      { name: 'High Level Category', field: 'highLevelCategory', scalable: true},
      { name: 'Mid Level Category ID', field: 'midLevelId', scalable: true, headerBinding: headerWithLink1,styles: styles },
      { name: 'Mid Level Category', field: 'midLevelCategory', scalable: true},
      { name: 'PUBLIC', field: 'public', scalable: true, filterInput: false, headerBinding: headerWithLink.bind(null, "Non Professional", "free"),binding: textWithIcon.bind(null, "yes"),styles: styles },
      { name: 'PRIVATE', field: 'private', scalable: true, filterInput: false, headerBinding: headerWithLink.bind(null, "Non Professional", "private"),binding: textWithIcon.bind(null, "yes")},
      { name: 'INTERNAL PROFESSIONAL', field: 'professional', scalable: true, filterInput: false, headerBinding: headerWithLink.bind(null, "Private", "professional"), binding: textWithIcon.bind(null, "yes"), styles: styles}
    ]

    function headerWithLink(text, i, e) {
      let cell = e.cell;
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        let link = content._link = document.createElement("ef-icon");
        link.icon = "link";
        link.style.color = "blue";
        content.addEventListener("click", function(arg) {
          arg.stopPropagation();
          setView("wealth");
        });
        let image = content._span1 = document.createElement("img");
        image.style.position = "absolute";
        image.style.top = "10px";
        image.style.right = "5px";
        image.style.width = "38px";
        image.src = resolveImage(i);
        let span2 = content._span2 = document.createElement("span");
        span2.style.display = "block";
        span2.style.fontWeight = 400;
        content.appendChild(span);
        content.appendChild(link);
        content.appendChild(span2);
        content.appendChild(image);
      }

      content._span.textContent = e.columnDef.getName();
      content._span2.textContent = text;
      cell.setContent(content);
    };

    function headerWithLink1(e) {
      let cell = e.cell;
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        let link = content._link = document.createElement("ef-icon");
        link.icon = "link";
        link.style.color = "blue";
        content.addEventListener("click", function(arg) {
          arg.stopPropagation();
          if(e.columnDef.getName() === "High Level Category ID") {
            setView("highLevel");
          }
          if(e.columnDef.getName() === "Mid Level Category ID") {
            setView("midLevel");
          }
        });
        content.appendChild(span);
        content.appendChild(link);
      }

      content._span.textContent = e.columnDef.getName();
      cell.setContent(content);
    }

    function gridConfigured(e) {
      const core = e.detail.api.getCoreGrid();
      const header = core.getSection("title"); // the section is internally referred as title
      header.setRowHeight(0, 60); // Set row height of row 0 to 60 pixels
      core.setColumnWidths([150, 180, 200, 180, 200, 180, 200, 250, 250, 250], false);
    }

    if(view === "default") {
      grid.config = {
        rowHeight: 60,
        autoHideScrollbar: false,
        columns: columns,
        dataModel: {
          data: data
        },
        sorting: {
          sortableColumns: false,
          initialSort: {
              colIndex: 0, // Column index
              sortOrder: "a"
          }
        },
        rowFiltering: {
          disabledUI: true
        },
        autoTooltip: {
          title: true
        },
        extensions: [
          rowFilteringExt,
          filterInputExt,
          autoToolTipExt
        ]
      };
      grid.addEventListener('configured', gridConfigured);
    }
  }, [ setView, view, data]);

  return (
    <div>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      {view === "wealth" && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setView("default")}>Back</ef-button>
          <WealthPackages />
        </div>
      )}
      {view === "highLevel" && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setView("default")}>Back</ef-button>
          <HighLevel />
        </div>
      )}
      {view === "midLevel" && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setView("default")}>Back</ef-button>
          <MidLevel />
        </div>
      )}
      {view === "default" && (
        <ef-layout>
          <ef-layout>
            <p className='commentP'>This is a US SEC direct document feed.</p>
            <p className='commentP'>EDGAR, the Electronic Data Gathering, Analysis, and Retrieval system, performs automated collection, validation, indexing, acceptance, and forwarding of submissions by companies and others who are required by law to file forms with the U.S. Securities and Exchange Commission (SEC). Its primary purpose is to increase the efficiency and fairness of the securities market for the benefit of investors, corporations, and the economy by accelerating the receipt, acceptance, dissemination, and analysis of time-sensitive corporate information filed with the agency.</p>
          </ef-layout>
          <ef-layout>
            <efx-grid id="grid" className="filings-grid"></efx-grid>
          </ef-layout>
        </ef-layout>
      )}
    </div>
  );
}

function DocumentType({flag = true}) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [searchData, setSearchData] = useState([]);

  function searchEvent(val) {    
    setSearchData(data.filter(item => item.searchkey.toLowerCase().includes(val.toLowerCase())));
  }

  useEffect(() => {
    fetchData("Filings_Sections").then(res => {
      setData(res);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const grid = document.getElementById("grid");
    const columns = [
      { name: 'Sections', field: 'searchableSections', scalable: true},
      { name: '8-k', field: '8k', leftPinned: true, scalable: true, styles: styles,binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: '10-k', field: '10k', scalable: true,binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: '10-Q', field: '10Q', scalable: true, styles: styles,binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: '20-F', field: '20f', scalable: true, binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: '40-F', field: '40f', scalable: true, styles: styles, binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: 'PROXY', field: 'proxy', scalable: true, binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: 'PROSP', field: 'prosp', scalable: true, styles: styles, binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: 'REGST', field: 'regst', scalable: true, binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: 'ARS', field: 'ars', scalable: true, styles: styles, binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: 'Williams Act', field: 'williamsAct', scalable: true, styles: styles, binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: 'SC 13G', field: 'sc13G', leftPinned: true, scalable: true, binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: 'SC TO-T', field: 'scToT', scalable: true, styles: styles, binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: 'SC 13D', field: 'sc13D', scalable: true, binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: 'SC TO-I', field: 'scToI', scalable: true,  styles: styles, binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: 'SC 13E3', field: 'sc13E3', scalable: true, binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: 'SC 14D9', field: 'sc14D9', scalable: true,  styles: styles, binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: 'SC 13E4', field: 'sc13E4', scalable: true, binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: 'SC 14F1', field: 'sc14F1', scalable: true, styles: styles,  binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: 'SC 13E4F', field: 'sc13E4F', scalable: true, binding: textWithIcon.bind(null, "x"), alignment: "center"},
      { name: 'SC 13E1', field: 'sc13E1', scalable: true, styles: styles, binding: textWithIcon.bind(null, "x"), alignment: "center"}
    ]
    columns.forEach((col,i) => {
      if(i === 0){
        return;
      }else if(i<10){
        col.visible = flag;
      }else{
        col.visible = !flag;
      }
    });

    function gridConfigured(e) {
      const core = e.detail.api.getCoreGrid();
      core.setColumnWidths([100, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20], true);
    }

    grid.config = {
      rowHeight: 60,
      headerRowHeight: 60,
      columns: columns,
      dataModel: {
        data: searchData.length > 0 ? searchData : data
      },
      sorting: {
        sortableColumns: false,
        initialSort: {
            colIndex: 0, // Column index
            sortOrder: "a"
        }
      },
    };
    grid.addEventListener('configured', gridConfigured);
  }, [data, searchData, flag]);
  

  return (
    <div>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
        <ef-layout flex style={{ marginTop: '20px' }}>
        <ef-layout>
          <input
            className='search-field'
            type="text"
            placeholder="Type to search..."
            onChange={(e) => searchEvent(e.target.value)}
          />
        </ef-layout>
      </ef-layout>
      <ef-layout>
        <efx-grid id="grid" className="entity-grid"></efx-grid>
      </ef-layout>
    </div>
  );
}

export default function Edgar() {
  const [documentTab, setDocumentTab] = useState("Document_Mapping");
  const [documentMappingView, setDocumentMappingView] = useState("default");

  return (
    <div className='main-div'>
      {!(documentTab === "Document_Mapping" && documentMappingView !== "default") && (
        <ef-layout>
          <h4>Edgar</h4>
          <ef-button-bar className="data-fields-btn-bar" managed>
            <ef-button toggles active icon="dsc-move-charts" onClick={() => setDocumentTab("Document_Mapping")}>Document Mapping</ef-button>
            <ef-button toggles icon="map-chart" onClick={() => setDocumentTab("Document_Type")}>Document Type</ef-button>
            <ef-button toggles icon="text" onClick={() => setDocumentTab("Form_Type")}>Form Type</ef-button>
          </ef-button-bar>
        </ef-layout>
      )}
      {documentTab === "Document_Mapping" && (
        <DocumentMapping view={documentMappingView} setView={setDocumentMappingView} />
      )}
      {documentTab === "Document_Type" && <DocumentType />}
      {documentTab === "Form_Type" && <DocumentType flag={false} />}
    </div>
  );
}